import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongtinlaixe from "components/Danhmuc/Laixe/Thongtinlaixe.js";
export default function TTlaixe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Thông tin lái xe",
            tabContent: <Thongtinlaixe />,
          },
        ]}
      />
    </div>
  );
}
